// Standard question set for an ePCR record audit. The server stores whatever
// responses it is sent, so this list can evolve without a migration - completed
// audits keep the questions they were answered against.
const AUDIT_CRITERIA = [
  {
    name: 'History & presenting complaint documented',
    guidance:
      'The history of events and presenting complaint are recorded clearly and support the working impression.',
  },
  {
    name: 'Assessment & observations recorded',
    guidance:
      'A structured assessment is documented with vital signs recorded and repeated where appropriate.',
  },
  {
    name: 'Treatment appropriate & documented',
    guidance:
      'Interventions were clinically appropriate, within scope of practice, and fully documented.',
  },
  {
    name: 'Medicines recorded correctly',
    guidance:
      'Any medicines given are recorded with drug, dose, route, time, and authorisation.',
  },
  {
    name: 'Outcome & disposition appropriate',
    guidance:
      'The patient outcome (discharge, referral, or transport) was safe and appropriate, with worsening advice documented where relevant.',
  },
  {
    name: 'Record complete & professional',
    guidance:
      'The record is complete, legible, professional, and signed off with times recorded.',
  },
]

export default AUDIT_CRITERIA
